import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { IoIosArrowBack as Back } from "react-icons/io";
import { IoIosArrowForward as Forward } from "react-icons/io";
import Footer from "./Footer";

const NavigationStyles = styled.div`
  width: 80%;
  margin: 0;
  padding: 0;
  padding-bottom: 40px;
  }
  .icon {
      position: relative;
      top: 2px;
  }
  
  .left {
    float: left;
    padding-right: 5px;
  }
  .right {
    float: right;
    padding-left: 5px;
  }
`;

export default function BottomNav({ current }) {
  let forward = current + 1;
  let back = current - 1;
  if (back === 0) {
    back = "quote";
  }
  if (back === -1) {
    back = "title";
  }
  if (back === -2) {
    back = "";
  }
  if (forward === 0) {
    forward = "quote";
  }
  if (forward === 84) {
    forward = "end";
  }

  return (
    <>
      <NavigationStyles>
        <Link to={`/${back}`} className="nav-button left">
          <Back className="icon" />
          पीछे
        </Link>
        <Link to={`/${forward}`} className="nav-button right">
          आगे
          <Forward className="icon" />
        </Link>
      </NavigationStyles>
      <Footer />
    </>
  );
}
